import { render, staticRenderFns } from "./RoleInfoGrid.vue?vue&type=template&id=a77b1dbe&lang=true"
import script from "./RoleInfoGrid.vue?vue&type=script&lang=js"
export * from "./RoleInfoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports